/*!
 * Copyright (c) Microsoft Corporation.
 * All rights reserved. See LICENSE in the project root for license information.
 */

import * as React from 'react';
import { IHosports4ColumnImagesViewProps } from './hosports-4-column-images';

export default (props: IHosports4ColumnImagesViewProps) => {
    return (
        <h2>{'hosports-four-column-images-view'}</h2>
    );
};
